<template>
  <div class="x3page">
    <div class="x3main">
      <van-field
        v-model="params.name"
        label="收费类型名称"
        input-align="right"
        required
        maxlength="8"
        :formatter="v => v.trim()"
        placeholder="请输入，8个字以内"
      />
      <van-field label="启用状态" input-align="right">
        <template #input>
          <van-switch :value="params.enable == 1" size="20" @input="onInput()" />
        </template>
      </van-field>
      <div class="tips" v-if="params.id">
        如果修改了“收费类型名称”，则保存后原已引用该类型的订单也将同步替换为新的名称
      </div>
    </div>

    <x3-foot-btn
      :showCancelButton="!!params.id"
      cancelText="删除"
      @cancel="delHandler"
      confirmText="保存"
      @confirm="saveHandler"
    ></x3-foot-btn>
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
import x3FootBtn from '@x3/vue/comp/x3-foot-btn.vue';
export default {
  name: 'sf-type-add',
  components: {
    pageFooterBtn,
    x3FootBtn,
  },
  data() {
    return {
      pageTitle: this.$vxRoute.query.id ? '编辑收费类型' : '新增收费类型',
      params: {
        id: this.$vxRoute.query.id || '',
        name: this.$vxRoute.query.name || '',
        enable: this.$vxRoute.query.enable || 1,
      },
    };
  },
  methods: {
    onInput() {
      this.params.enable = (Number(this.params.enable) + 1) % 2;
    },
    verify() {
      let msg = '';
      if (!this.params.name) {
        msg = '请填写收费类型名称';
        return msg;
      }
      return msg;
    },
    // 新增
    async add() {
      await this.$api.createOrderFlag(this.params);
      vant.Toast('新增成功');
      this.$router.back();
      app.vue.$emit('add-sf_type-success');
    },

    // 编辑
    async edit() {
      // await vant.Dialog.confirm({
      //   title: '提示',
      //   message: '修改的信息将替换对学员已标记的信息。是否确认修改？',
      // });

      await this.$api.orderFlagEdit(this.params);
      vant.Toast('编辑成功');
      this.$router.back();
      app.vue.$emit('edit-sf_type-success');
    },

    async saveHandler() {
      let err = this.verify();
      if (err) {
        return vant.Toast(err);
      }
      this.showLoading();

      if (this.params.id) {
        await this.edit();
      } else {
        await this.add();
      }
      vant.Toast.clear();
    },
    async delHandler() {
      await this.$api.deleteOrderFlag(this.params.id);
      vant.Toast('删除成功');
      this.$router.back();
      app.vue.$emit('edit-sf_type-success');
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  padding: calc(var(--gap) * 8) calc(var(--gap) * 16) calc(var(--gap) * 16);
  color: var(--g6);
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}
</style>